import { compose, propOr, values, flatten, head } from 'ramda';

const FreeTrialDuration = compose(
  propOr('P7D', 'free_trial_duration'),
  head,
  flatten,
  values,
  head,
  values,
  head,
  propOr([], 'items'),
);

export { FreeTrialDuration };
